<template>
  <div class="" v-if="invoice">
    <el-form :model="formDocument" :rules="rules" ref="formDocument">
      <TopBarTitleComponent title="Editar Factura" :showBackIcon="true">
        <template slot="right-area">
          <div class="d-flex justify-content-end align-items-center">
            <ButtonPrimaryComponent
              title="Guardar"
              @onSaveClick="handleSaveClick"
            />
          </div>
        </template>
      </TopBarTitleComponent>
      <b-container fluid class="pb-4 px-lg-4 pt-4">
        <b-row>
          <b-col>
            <div class="card box-shadow" v-if="apiResponse.success">
              <div class="card-body">
                <b-row>
                  <b-col xs="12" sm="12" md="12">
                    <b-row>
                      <b-col xs="12" sm="12" md="4">
                        <el-form-item prop="user_business_client_id">
                          <SelectBusinessComponent
                            @onChangeSelect="onChangeSelectBusiness"
                            :setUserBusinessClientId="
                              formDocument.user_business_client_id
                            "
                            :setClient="invoice ? invoice.client : null"
                          />
                        </el-form-item>
                      </b-col>
                      <b-col xs="12" sm="12" md="4">
                        <el-form-item prop="email">
                          <slot name="label">
                            <label class="font-semi-bold m-0">Correo</label>
                          </slot>
                          <el-input
                            type="text"
                            placeholder=""
                            class=""
                            v-model="formDocument.email"
                          ></el-input>
                        </el-form-item>
                      </b-col>
                      <b-col xs="12" sm="12" md="4">
                        <el-form-item prop="user_business_e_point_id">
                          <SelectEmissionPointsComponent
                            @onChangeSelect="onChangeSelectEmissionPoints"
                            :setEmissionPointId="
                              formDocument.user_business_e_point_id
                            "
                            :disabled="hasProducts"
                          />
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col xs="12" sm="12" md="4">
                        <InputDatePickerComponent
                          @onChangeDatePicker="onChangeDatePicker"
                          prop="emission_date"
                          placeholder=""
                          title="Fecha de emisión"
                          :setDate="formDocument.emission_date"
                          :isDisabledDate="true"
                        />
                      </b-col>
                      <b-col xs="12" sm="12" md="4">
                        <el-form-item prop="sri_forms_payment_id">
                          <slot name="label">
                            <label class="font-semi-bold m-0"
                              >Formas de pago</label
                            >
                          </slot>
                          <SelectSriFormsPaymentsComponent
                            :setSriFormsPaymentId="
                              formDocument.sri_forms_payment_id
                            "
                            @onChangeSelect="onChangeSriFormsPaymentsSelect"
                          />
                        </el-form-item>
                      </b-col>
                      <b-col xs="12" sm="12" md="4">
                        <el-form-item style="margin-top:0">
                          <slot name="label">
                            <label class="font-semi-bold m-0"
                              >Proyecto (opcional)</label
                            >
                          </slot>
                          <el-select
                            v-model="formDocument.project_id"
                            placeholder="Sin proyecto"
                            clearable
                            filterable
                            style="width:100%"
                          >
                            <el-option
                              v-for="proj in projects"
                              :key="proj.id"
                              :label="proj.name"
                              :value="proj.id"
                            />
                          </el-select>
                          <small
                            style="color:#888;margin-top:4px;display:block;font-size:11px"
                          >
                            <a
                              @click="$router.push({ name: 'projects' })"
                              style="color:#3ecfb4;cursor:pointer"
                              >+ Crear nuevo proyecto</a
                            >
                          </small>
                        </el-form-item>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <TableInputProducts
                  @onToogleProducts="onToogleProducts"
                  :setProducts="formDocument.products"
                  :setEmissionPointId="formDocument.user_business_e_point_id"
                  validate-stock
                  validate-emission-point
                />
                <section class="aditional-documents mt-4">
                  <b-row class="invoice-bottom-row">
                    <b-col
                      xs="12"
                      sm="12"
                      md="4"
                      offset-md="0"
                      order="1"
                      order-md="2"
                      class="mb-3 mb-md-0 ml-md-auto"
                    >
                      <DocumentCalculator
                        :setProducts="formDocument.products"
                        :setDisc="formDocument.discount"
                        @onChangeSwitchDiscount="onChangeSwitchDiscount"
                        @onTotalChange="onCalcTotalChange"
                      />
                    </b-col>
                    <b-col xs="12" sm="12" md="6" order="2" order-md="1">
                      <InvoicePaymentConditionsComponent
                        :invoiceTotal="invoiceTotal"
                        :initialMethodPayment="formDocument.method_payment || 1"
                        :initialLimitCredit="formDocument.limit_credit || ''"
                        :initialLimitCreditAt="
                          formDocument.limit_credit_at || ''
                        "
                        :initialObservationAdvance="
                          formDocument.observation_advance || ''
                        "
                        @onChange="onPaymentConditionsChange"
                      />
                    </b-col>
                  </b-row>
                  <b-row class="mt-3">
                    <b-col xs="12" sm="12" md="6">
                      <DocumentAdditionalInfoComponent
                        :additionalExtras="formDocument.additional_extras"
                        @onAdditionals="onAdditionals"
                      />
                    </b-col>
                  </b-row>
                </section>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </el-form>
  </div>
</template>

<script>
import TopBarTitleComponent from "../../../../components/TopBarTitle";
import invoiceService from "../services/invoiceService";
import projectService from "../../projects/services/projectService";
import ButtonPrimaryComponent from "../../../../components/ButtonPrimary";
import SelectBusinessComponent from "../../../../components/SelectBusiness";
import SelectEmissionPointsComponent from "../../../../components/SelectEmissionPoints";
import InputDatePickerComponent from "../../../../components/InputDatePicker";
import TableInputProducts from "../../../components/TableInputProducts";
import SelectSriFormsPaymentsComponent from "../../../../components/SelectSriFormsPayments";
import DocumentAdditionalInfoComponent from "../../../components/DocumentAdditionalInfo";
import DocumentCalculator from "../../../components/DocumentCalculator";
import InvoicePaymentConditionsComponent from "../components/InvoicePaymentConditions";
import Validate from "@/assets/validate";

export default {
  name: "InvoiceViewPage",
  data: () => ({
    invoiceTotal: 0,
    apiResponse: {
      success: false,
      message: null
    },
    invoice: null,
    projects: [],
    formDocument: {
      user_business_client_id: "",
      emission_date: "",
      user_business_e_point_id: "",
      sri_forms_payment_id: "",
      discount: 0,
      discount_type: "",
      email: "",
      user_business_id: "",
      products: [],
      additional_extras: [],
      method_payment: null,
      project_id: null
    },
    rules: {
      user_business_client_id: [Validate.rules.required("change")],
      user_business_e_point_id: [Validate.rules.required("change")],
      sri_forms_payment_id: [Validate.rules.required("change")],
      emission_date: [Validate.rules.required("change")],
      email: [Validate.rules.required()]
    }
  }),
  computed: {
    hasProducts() {
      return this.formDocument.products.length > 0;
    }
  },
  methods: {
    toggleApiResponse(property, value) {
      this.apiResponse[property] = value;
    },
    goPage(name) {
      this.$router.push({ name });
    },
    async getInvoice(invoiceId) {
      this.$store.dispatch("toggleRequestLoading");
      try {
        let response = await invoiceService
          .getInvoceId(invoiceId)
          .finally(() => {
            this.$store.dispatch("toggleRequestLoading");
          });
        if (response) {
          this.invoice = response.data.data;
          this.handleDataForm();
          this.toggleApiResponse("success", true);
        }
      } catch (error) {
        return false;
      }
    },
    handleSaveClick() {
      this.$refs.formDocument.validate(async valid => {
        if (valid) {
          this.$store.dispatch("toggleRequestLoading");
          try {
            const payload = {
              ...this.formDocument,
              products: this.formDocument.products.map(p => ({
                ...p,
                product_code: p.code
              }))
            };
            let response = await invoiceService
              .updateInvoiceId(this.invoice.id, payload)
              .finally(() => {
                this.$store.dispatch("toggleRequestLoading");
              });
            const { success, message } = response.data;
            if (success) {
              this.$notifications.success({ message });
              this.$router.push({
                name: "sales.invoices.view",
                params: { id: this.invoice.id }
              });
            }
          } catch (error) {
            return false;
          }
        }
      });
    },
    handleDataForm() {
      const {
        user_business_client_id,
        user_business_id,
        products,
        user_business_e_point_id,
        sri_forms_payment_id,
        emission_date,
        email,
        discount,
        discount_type,
        additional_extras,
        method_payment,
        limit_credit,
        limit_credit_at,
        observation_advance,
        project_id
      } = this.invoice;

      const mappedProducts = products.map(p => ({
        ...p,
        code: p.product_code || (p.product && p.product.code) || p.code,
        original_code: p.product ? p.product.code : p.product_code || p.code,
        alternative_code: p.product ? p.product.alternative_code : null,
        name: p.product ? p.product.name : p.name
      }));

      this.formDocument = {
        ...this.formDocument,
        ...{
          user_business_client_id,
          user_business_id,
          products: mappedProducts,
          user_business_e_point_id,
          sri_forms_payment_id,
          emission_date,
          email,
          discount,
          discount_type,
          additional_extras,
          method_payment,
          limit_credit,
          limit_credit_at,
          observation_advance,
          project_id: project_id || null
        }
      };
    },
    onChangeSelectBusiness({ client }) {
      const { email, id } = client;
      this.formDocument.email = email;
      this.formDocument.user_business_client_id = id;
    },
    onChangeSelectEmissionPoints({ emissionPointId }) {
      this.formDocument.user_business_e_point_id = emissionPointId;
    },
    onChangeDatePicker({ date }) {
      this.formDocument.emission_date = date;
    },
    onToogleProducts({ products }) {
      this.formDocument.products = [...products];
    },
    onChangeSwitchDiscount({ discount, type }) {
      this.formDocument.discount = discount;
      this.formDocument.discount_type = type;
    },
    onChangeSriFormsPaymentsSelect({ sriFormsPaymentsSelect }) {
      this.formDocument.sri_forms_payment_id = sriFormsPaymentsSelect;
    },
    onAdditionals({ additionals }) {
      this.formDocument.additional_extras = additionals;
    },
    onPaymentConditionsChange(payload) {
      Object.assign(this.formDocument, payload);
    },
    onCalcTotalChange(total) {
      this.invoiceTotal = total;
    },
    async loadProjects() {
      try {
        const res = await projectService.getProjects({
          skipErrorNotification: true
        });
        this.projects = res.data.data || [];
      } catch (e) {
        /* silent */
      }
    }
  },
  components: {
    TopBarTitleComponent,
    ButtonPrimaryComponent,
    SelectBusinessComponent,
    SelectEmissionPointsComponent,
    InputDatePickerComponent,
    TableInputProducts,
    SelectSriFormsPaymentsComponent,
    DocumentAdditionalInfoComponent,
    DocumentCalculator,
    InvoicePaymentConditionsComponent
  },
  mounted() {
    const { id: invoiceId } = this.$route.params;
    if (invoiceId) this.getInvoice(invoiceId);
    this.loadProjects();
  }
};
</script>

<style lang="scss" scoped>
.card-quotes-view {
  .card-quotes-view-header {
    .card-quotes-view-logo {
      flex-direction: column;
      height: 100%;
      p {
        margin: 0;
      }
    }
  }
  .card-quotes-view-body-products {
    min-height: 300px;
  }
}
</style>
